module.exports = __webpack_public_path__ + "static/media/flexiassets-banner.e9124c5c.jpg";